module.exports = __webpack_public_path__ + "media/images/icons/icon-explore-glass-6526fec71d7d2341b58852b5313c1511.svg";